<template>
  <div class="sing-in">
    <form @submit.prevent="submit" class="content p-3">
      <div class="row-item pt-5 mt-5 top">
        <img src="../../assets/images/logo-blue.svg" class="logo mb-5">
        <h3 class="mb-5">Sign in with your email and password:</h3>
        <input
          class="form-control mt-5"
          type="text"
          name="username"
          autocomplete="on"
          placeholder="username"
          v-model="form.username"
        >
        <input
          class="form-control mt-4"
          type="password"
          name="password"
          autocomplete="on"
          placeholder="password"
          v-model="form.password"
        >
        <div class="error">{{error}}</div>
        <div class="mt-4">Need an account? <router-link to="/sign-up">Sign up</router-link></div>
      </div>
      <div class="row-item">
        <button
          type="submit"
          class="btn btn-primary mt-4"
        >Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      error: '',
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated'
    })
  },
  methods: {
    ...mapActions('auth', ['signIn']),

    submit() {
      this.error = ''
      this.signIn(this.form).then(() => {
        this.$router.push('/')
      }).catch(({ message }) => {
        this.error = message
      })
    }
  },
  mounted() {
    if (!this.isAuthenticated) { return }

    this.$router.push('/')
  }
}
</script>


<style lang="scss" scoped>
.sing-in {
  display: flex;
  min-height: 100vh;
}

.content {
  margin: auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.top {
  text-align: center;
}

.logo {
  display: block;
  margin: auto;
}

.btn {
  display: block;
  width: 100%;
}

.error {
  padding: 15px 0;
  min-height: 60px;
  color: rgb(255, 98, 98);
}

</style>
